/**
 * Impostazioni: lo stop generale, sempre in cima qualunque sezione sia
 * aperta.
 */

import { useState } from "react";
import { Power } from "lucide-react";
import { api } from "../../lib/api.ts";
import { messaggioDi } from "../../lib/errori.ts";
import { useStore } from "../../lib/store.tsx";
import { Card, Toggle, cx } from "../../ui/primitives.tsx";

export function StopGenerale() {
  const store = useStore();
  const [busy, setBusy] = useState(false);
  const acceso = store.account?.killSwitch ?? false;

  const cambia = async (enabled: boolean) => {
    setBusy(true);
    try {
      await api.setKillSwitch(enabled);
      await store.refreshAccount();
      store.notify(
        enabled
          ? "Automazioni ferme. Non tocco più niente."
          : "Automazioni riattivate.",
      );
    } catch (errore) {
      store.notify(messaggioDi(errore));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card
      tone={acceso ? "danger" : "plain"}
      className={cx("p-4", acceso && "ring-1 ring-danger/30")}
    >
      <div className="flex items-center gap-3">
        <span
          className={cx(
            "grid size-10 shrink-0 place-items-center rounded-field",
            acceso
              ? "bg-danger text-ink-inverse"
              : "bg-surface-muted text-ink-soft",
          )}
        >
          <Power size={18} />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-bold text-ink">
            Stop generale{" "}
            <span
              className={cx(
                "ml-1 text-[13px] font-semibold",
                acceso ? "text-danger" : "text-ink-faint",
              )}
            >
              {acceso ? "attivo" : "spento"}
            </span>
          </p>
          <p className="mt-0.5 text-[13px] leading-relaxed text-ink-soft">
            {acceso
              ? "Otto ti fa vedere tutto, ma non scrive niente sul gestionale."
              : "Se lo accendi, Otto smette di modificare e di automatizzare. Continua a leggere."}
          </p>
        </div>
        <Toggle
          checked={acceso}
          onChange={cambia}
          label="Stop generale"
          tone="danger"
          disabled={busy}
        />
      </div>
    </Card>
  );
}
